import template from "./settings-team.html";

const SettingsTeamComponent = {
  template: template,

  controller: class SettingsTeamController {
    /* @ngInject */
    constructor(
      $rootScope,
      $filter,
      User,
      OrganizationService,
      Invitation,
      Notification,
      SweetAlertService,
      errorMessages,
    ) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.User = User;
      this.OrganizationService = OrganizationService;
      this.Invitation = Invitation;
      this.NotificationService = Notification;
      this.SweetAlertService = SweetAlertService;
      this.errorMessages = errorMessages;
    }

    async $onInit() {
      this.team = [];
      this.invitations = [];
      this.adminUsers = [];
      this.loadingInviting = false;
      this.loadingUsers = false;
      this.loadingInvitations = false;
      this.organization = this.$rootScope.organization;
      this.owner = this.organization.owner;
      this.inviteTo = null;
      this.emailsNotAllowed = this._generateEmailsNotAllowed();

      await this._refreshTeam();
      await this._refreshInvitations();
    }

    async invite() {
      if (!this.inviteUserForm.$valid) return;

      this.loadingInviting = true;
      const invitation = new this.Invitation({ email: this.inviteTo });

      await invitation.create();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.invite"),
      });
      this.inviteTo = null;
      this.inviteUserForm.$setPristine();
      await this._refreshTeam();
      await this._refreshInvitations();
      this.loadingInviting = false;
      this.$rootScope.$applyAsync();
    }

    async reInvite(invitation) {
      this.loadingInviting = true;
      try {
        await invitation.resend();
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.reInvite"),
        });
        await this._refreshTeam();
        await this._refreshInvitations();
        this.loadingInviting = false;
        this.$rootScope.$applyAsync();
      } catch (error) {
        this.loadingInviting = false;
        if (
          (error.status === 400 && error.data === "Inviting not allowed same day") ||
          error.message === "Inviting not allowed same day"
        ) {
          this.NotificationService.error({
            title: this.$filter("trans")("notificationService.title.ups"),
            message: this.$filter("trans")("errors.invitations.onlyOnceDay"),
          });
        } else {
          throw error;
        }
      }
    }

    isOwner(user) {
      return user.email === this.owner.email;
    }

    isSelfUser(user) {
      return user.email === this.$rootScope.user.email;
    }

    async removeUser(user) {
      if (!(await this.SweetAlertService.wantRemoveUser(user.displayName, this.organization.name))) return;
      await this.OrganizationService.removeUser(user.id);
      await this._refreshTeam();
      await this.SweetAlertService.userRemoved();
    }

    async removeInvitation(invitation) {
      if (!(await await this.SweetAlertService.wantRemoveInvitation(invitation.email, this.organization.name))) return;
      await invitation.remove();
      await this._refreshInvitations();
      await this.SweetAlertService.invitationRemoved();
    }

    async toggleAdmin(user) {
      await this.OrganizationService.toggleAdmin(user.id);
    }

    async _refreshTeam() {
      this.loadingUsers = true;
      this.team = await this.User.getTeam();
      this.emailsNotAllowed = this._generateEmailsNotAllowed();
      this.adminUsers = [];
      this.team.forEach((user) => {
        if (this.$rootScope.organization.isAdmin(user)) this.adminUsers.push(true);
        else this.adminUsers.push(false);
      });
      this.loadingUsers = false;
      this.$rootScope.$applyAsync();
    }

    async _refreshInvitations() {
      this.loadingInvitations = true;
      this.invitations = await this.Invitation.query();
      this.emailsNotAllowed = this._generateEmailsNotAllowed();
      this.loadingInvitations = false;
      this.$rootScope.$applyAsync();
    }

    showToggle(user) {
      return !this.$rootScope.organization.isOwner(user) && this.$rootScope.organization.isOwner(this.$rootScope.user);
    }

    _generateEmailsNotAllowed() {
      return [].concat(
        this.invitations.map((invitation) => invitation.email),
        this.team.map((user) => user.email),
      );
    }
  },
};

export default SettingsTeamComponent;
